import {getCookie, setCookie} from "@/Utilities/CookieManager";

export default function AddOnSummary({state, dispatch}) {

    const handleRemoveOnClick = (addOn) => {
        let newValue = [];
        const cartCookie = 'cartProducts';
        const currentCart = getCookie(cartCookie);

        if (typeof currentCart !== "undefined") {
            newValue = currentCart.filter(item => item !== addOn.productId);
        }
        dispatch({ type: "removeFromCart", payload: { removeFromCart: addOn }})

        setCookie(cartCookie, newValue, 3);
        dispatch({ type: "cartCookies", payload: { cartCookies: getCookie(cartCookie) }});
    }

    return (
        <div>
            {state.cart.filter(item => item.type === "add-on").map((addOn, index) => {
                if (addOn.productType.toLowerCase() !== 'usage') {
                    return (
                        <div key={index} className="add-on-summary d-flex">
                        <span className="my-auto">
                            <span className="summary-add-on-name">{addOn.name}</span>
                        </span>
                            <span className="add-on-price-container">
                            <span className="add-on-price">${addOn.price}</span>
                        </span>
                            { !addOn.required && (
                                <i className="fa fa-times"
                                   data-qa={`${addOn.name.toLowerCase().replace(' ', '-')}-custom-summary-remove`}
                                   onClick={() => handleRemoveOnClick(addOn)}/>
                            )}
                        </div>
                    )
                }
            })}
        </div>
    )
}
